module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "disqus_thread"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c53f3fc8","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/blog/VueDisqus.vue
// module id = 368
// module chunks = 0